// eslint-disable-next-line no-undef
const publicPath = PUBLIC_PATH;
export default publicPath;

// eslint-disable-next-line no-undef
const publicPathBaseUrl = PUBLIC_PATH_BASE_URL;
export { publicPathBaseUrl };
